module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Baptiste_1.1a9cf4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Baptiste_1.jpg
// module id = pwYQ
// module chunks = 0